import React, { Component } from "react";
import { Button, ButtonToolbar, ButtonGroup } from "react-bootstrap";
import { sclist } from "../../sc.json";
import { sclistOld } from "../../sc_old.json";
class ListGroup extends Component {

  handelSelectsc_new1 = ({ currentTarget: input }) => {
    ////console.log(this.props.currentsc_new1 );
    ////console.log(input.value);
    if (this.props.currentsc_new1 === input.value) {
      const btn = { title: input.value, name: "1" };
      this.props.onItemSelect(btn);
    } else {
      const btn = { title: "", name: "1" };
      this.props.onItemSelect(btn);
    }

  };
  handelSelectsc_new2 = event => {
    ////console.log(event);
    if (this.props.currentsc_new2 === event.target.value) {
      const btn = { title: "", name: "2" };
      this.props.onItemSelect(btn);
    } else {
      const btn = { title: event.target.value, name: "2" };
      this.props.onItemSelect(btn);
    }
  };
  handelSelectsc_new3 = event => {
    if (this.props.currentsc_new3 === event.target.value) {
      const btn = { title: "", name: "3" };
      this.props.onItemSelect(btn);
    } else {
      const btn = { title: event.target.value, name: "3" };
      this.props.onItemSelect(btn);
    }
  };
  handelSelectsc_new4 = event => {
    if (this.props.currentsc_new4 === event.target.value) {
      const btn = { title: "", name: "4" };
      this.props.onItemSelect(btn);
    } else {
      const btn = { title: event.target.value, name: "4" };
      this.props.onItemSelect(btn);
    }
  };
  handelSelectMufasser = event => {
    const btn = { title: event.target.value, name: "5" };
    this.props.onItemSelect(btn, "5");
  };
  handelSelectSC = event => {
    ////console.log(event.target.value);
    const btn = { title: event.target.value, name: "6" };
    this.props.onItemSelect(btn, "6");
  };
  handelSelectStatus = event => {
    ////console.log(event.target.value);
    const btn = { title: event.target.value, name: "7" };
    this.props.onItemSelect(btn, "7");
  };

  handelSelectCustomerRate = event => {
    ////console.log(event.target.value);
    const btn = { title: event.target.value, name: "8" };
    this.props.onItemSelect(btn, "8");
  };

  render() {
    const {
      sc_new1,
      sc_new2,
      sc_new3,
      sc_new4,
      currentMufasser,
      currentSC,
      currentsc_new1,
      currentsc_new2,
      currentsc_new3,
      currentsc_new4,
      sc,
      pcode,
      selectedItem,
      onItemSelect,
      selectedStatus,
      dreams,
      customerRate
    } = this.props;
    const activeShortCodes = sclist || [];
    const legacyShortCodes = sclistOld || [];
    const currentShortCodeValue =
      currentSC === null || currentSC === undefined ? "الكل" : String(currentSC);
    const currentShortCodeNumber = parseInt(currentShortCodeValue, 10);
    const legacySelectedValue = legacyShortCodes.some(
      (item) => item.sc === currentShortCodeNumber
    )
      ? currentShortCodeValue
      : "الكل";
    const activeSelectedValue = activeShortCodes.some(
      (item) => item.sc === currentShortCodeNumber
    )
      ? currentShortCodeValue
      : "الكل";

    return (
      <React.Fragment>
        <ButtonToolbar className="control-toolbar">
          <div className="control-toolbar__groups">
            {sc_new1 && sc_new1.length > 0 && (
              <ButtonGroup>
                {sc_new1.map((item) => (
                  <Button
                    onClick={() => onItemSelect(item, "1")}
                    key={item["title"]}
                    className={
                      item["title"] === currentsc_new1
                        ? "list-group-item active"
                        : "list-group-item"
                    }
                  >
                    {item["title"]}
                  </Button>
                ))}
              </ButtonGroup>
            )}
            {sc_new4 && sc_new4.length > 0 && (
              <ButtonGroup>
                {sc_new4.map((item) => (
                  <Button
                    onClick={() => onItemSelect(item, "4")}
                    key={item["title"]}
                    className={
                      item["title"] === currentsc_new4
                        ? "list-group-item active bg-danger"
                        : "list-group-item"
                    }
                  >
                    {item["title"]}
                  </Button>
                ))}
              </ButtonGroup>
            )}
            {sc_new2 && sc_new2.length > 0 && (
              <ButtonGroup>
                {sc_new2.map((item) => (
                  <Button
                    onClick={() => onItemSelect(item, "2")}
                    key={item["title"]}
                    className={
                      item["title"] === currentsc_new2
                        ? "list-group-item active bg-info"
                        : "list-group-item"
                    }
                  >
                    {item["title"]}
                  </Button>
                ))}
              </ButtonGroup>
            )}
            {sc_new3 && sc_new3.length > 0 && (
              <ButtonGroup>
                {sc_new3.map((item) => (
                  <Button
                    onClick={() => onItemSelect(item, "3")}
                    key={item["title"]}
                    className={
                      item["title"] === currentsc_new3
                        ? "list-group-item active bg-success"
                        : "list-group-item"
                    }
                  >
                    {item["title"]}
                  </Button>
                ))}
              </ButtonGroup>
            )}
          </div>
          {pcode === 999 ? (
            <div className="control-toolbar__selects">
              {legacyShortCodes.length ? (
                <div className="control-select">
                  <label
                    className="control-select__label"
                    htmlFor="legacy-shortcode-select"
                  >
                    شورت كود غير فعال قديم
                  </label>
                  <select
                    id="legacy-shortcode-select"
                    className="selectpicker"
                    value={legacySelectedValue}
                    onChange={this.handelSelectSC}
                  >
                    <option value="الكل" key="legacy-all">
                      الكل
                    </option>
                    {legacyShortCodes.map((item) => (
                      <option value={item.sc} key={item.sc}>
                        {item.details} {" - "} {item.sc}
                      </option>
                    ))}
                  </select>
                </div>
              ) : (
                ""
              )}
              {activeShortCodes.length ? (
                <div className="control-select">
                  <label
                    className="control-select__label"
                    htmlFor="active-shortcode-select"
                  >
                    شورت كود أحلامكم
                  </label>
                  <select
                    id="active-shortcode-select"
                    className="selectpicker"
                    value={activeSelectedValue}
                    onChange={this.handelSelectSC}
                  >
                    <option value="الكل" key="active-all">
                      الكل
                    </option>
                    {activeShortCodes.map((item) => (
                      <option value={item.sc} key={item.sc}>
                        {item.details} {" - "} {item.sc}
                      </option>
                    ))}
                  </select>
                </div>
              ) : (
                ""
              )}
              <select
                className="selectpicker"
                onChange={this.handelSelectMufasser}
              >
                <option
                  value="الكل"
                  key="الكل"
                  className={
                    "الكل" === selectedItem
                      ? "list-group-item active  bg-info"
                      : "list-group-item"
                  }
                >
                  "المفسر"
                </option>

                <option
                  value="adib@salmustasharak.com"
                  key="adib@salmustasharak.com"
                  className={
                    "adib@salmustasharak.com" === selectedItem
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  "أديب"
                </option>

                <option
                  value="mohannad@salmustasharak.com"
                  key="mohannad@salmustasharak.com"
                  className={
                    "mohannad@salmustasharak.com" === selectedItem
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  "منى"
                </option>
              </select>
              <select
                className="selectpicker"
                onChange={this.handelSelectStatus}
              >
                <option
                  value="الكل"
                  key="الكل"
                  className={
                    "الكل" === selectedItem
                      ? "list-group-item active  bg-info"
                      : "list-group-item"
                  }
                >
                  "الحالات"
                </option>
                <option
                  value="تساؤل"
                  key="تساؤل"
                  className={
                    "تساؤل" === selectedStatus
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  "تساؤل"
                </option>
                <option
                  value="دعم فني"
                  key="دعم فني"
                  className={
                    "دعم فني" === selectedStatus
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  "دعم فني"
                </option>
                <option
                  value="العاجل"
                  key="العاجل"
                  className={
                    "تساؤل" === selectedStatus
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  "العاجل"
                </option>
                <option
                  value="تدقيق"
                  key="تدقيق"
                  className={
                    "تدقيق" === selectedStatus
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  "تدقيق"
                </option>
                <option
                  value="شكوى"
                  key="شكوى"
                  className={
                    "شكوى" === selectedStatus
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  "شكوى"
                </option>

                <option
                  value="استخارة"
                  key="استخارة"
                  className={
                    "استخارة" === selectedStatus
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  "استخارة"
                </option>

                <option
                  value="حذف"
                  key="حذف"
                  className={
                    "حذف" === selectedStatus
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  "حذف"
                </option>

                <option
                  value="مكرر"
                  key="مكرر"
                  className={
                    "مكرر" === selectedStatus
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  "مكرر"
                </option>

                <option
                  value="استشارة"
                  key="استشارة"
                  className={
                    "استشارة" === selectedStatus
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  "استشارة"
                </option>
                <option
                  value="ناقص لا يفسر"
                  key="ناقص لا يفسر"
                  className={
                    "ناقص لا يفسر" === selectedStatus
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  "ناقص لا يفسر"
                </option>
                <option
                  value="شكر"
                  key="شكر"
                  className={
                    "شكر" === selectedStatus
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  "شكر"
                </option>
              </select>
              <select
                className="selectpicker"
                onChange={this.handelSelectCustomerRate}
              >
                <option
                  value="100"
                  key="100"
                  className={
                    "100" === customerRate
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  عادي
                </option>

                <option
                  value="1000"
                  key="1000"
                  className={
                    "1000" === customerRate
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  مهم جداً -{" "}
                  {
                    this.props.dreams.filter((x) => x.customerRate === 1000)
                      .length
                  }
                </option>
                <option
                  value="500"
                  key="500"
                  className={
                    "500" === customerRate
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  أحلامه كثيرة جداً -{" "}
                  {dreams.filter((x) => x.customerRate === 500).length}
                </option>

                <option
                  value="4"
                  key="4"
                  className={
                    "4" === customerRate
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  ثرثرة وسيئ -{" "}
                  {dreams.filter((x) => x.customerRate === 4).length}
                </option>

                <option
                  value="1"
                  key="1"
                  className={
                    "1" === customerRate
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  عجول جداً -{" "}
                  {dreams.filter((x) => x.customerRate === 1).length}
                </option>
                <option
                  value="9"
                  key="9"
                  className={
                    "9" === customerRate
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  عجول+عاجل -{" "}
                  {dreams.filter((x) => x.customerRate === 9).length}
                </option>
                <option
                  value="2222"
                  key="2222"
                  className={
                    "2222" === customerRate
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  خدمة التفسير سريع -{" "}
                  {dreams.filter((x) => x.customerRate === 2222).length}
                </option>
                <option
                  value="2"
                  key="2"
                  className={
                    "2" === customerRate
                      ? "list-group-item active"
                      : "list-group-item"
                  }
                >
                  للحذف الفوري -{" "}
                  {dreams.filter((x) => x.customerRate === 2).length}
                </option>
              </select>
            </div>
          ) : (
            ""
          )}
        </ButtonToolbar>
      </React.Fragment>
    );
  }
}

export default ListGroup;



// WEBPACK FOOTER //
// ./src/components/common/listGroup.jsx